import cn from 'classnames';
import React, { useEffect, useRef } from 'react';

import styles from './FormSlidesLoader.module.scss';
import { SlidesLoader } from './SlidesLoader';

interface InitialLoaderProps {
  isShowLoader: boolean;
  children: JSX.Element;
  onLoaderHidden?: (durationSeconds: number) => void;
}

/**
 * FormLoader необходим для показа <SlidesLoader/> процесса загрузки офферов/валидации анкеты
 */
export const FormSlidesLoader: React.FC<InitialLoaderProps> = ({ children, isShowLoader, onLoaderHidden }) => {
  const shownAtRef = useRef<number | null>(null);

  useEffect(() => {
    if (isShowLoader && shownAtRef.current === null) {
      shownAtRef.current = Date.now();
    }

    if (!isShowLoader && shownAtRef.current !== null) {
      const durationSeconds = Math.floor((Date.now() - shownAtRef.current) / 1000);

      onLoaderHidden?.(durationSeconds);

      shownAtRef.current = null;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isShowLoader]);

  return (
    <>
      {isShowLoader && <SlidesLoader />}
      <div className={cn({ [styles.hiddenContent]: isShowLoader })}>{children}</div>
    </>
  );
};
